import * as types from './types'

export default {
  [types.MUTATE_NEW_DISCOUNT_COUPON_SIDEBAR]: (state, payload) => {
    state.newDiscountCouponSidebar = {...state.newDiscountCouponSidebar, ...payload }
  },
  [types.MUTATE_DISCOUNT_COUPONS_SEARCH_RESULT]: (state, payload) => {
    state.discountCouponsSearchResult = payload
  },
}
